import React, { useState } from "react";
import { X } from "react-feather";
import { useIntl } from "react-intl";
import { validateCnpj, validateCpf } from "../../../../utils/validate";
import "./styles.scss";

const AddNewCpfCnpjModal = ({ onClose, onSend, onError }) => {
  const { formatMessage } = useIntl();
  const [cpfCnpj, setCpfCnpj] = useState("");

  function onClickHandler() {
    const value = cpfCnpj.replace(/[. /-]/g, "");

    if (!validateCpf(value) && !validateCnpj(value)) {
      onError(value);
    }

    onSend(value);
  }

  return (
    <>
      <div className="modal captcha-modal is-active">
        <div className="modal-background"></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <div className="modal-card-title">
              {formatMessage({ id: "adicionar-cpf-cnpj" })}
            </div>
            <X
              data-testid="close-button"
              className="close-button"
              onClick={onClose}
            />
          </header>
          <div className="modal-card-body">
            <input
              className="input"
              id="cpf-cnpj"
              type="text"
              onChange={e => setCpfCnpj(e.target.value)}
              value={cpfCnpj}
              placeholder="ex 999.999.999-99"
            />
          </div>
          <footer className="modal-card-foot">
            <button className="button" onClick={onClose}>
              {formatMessage({ id: "cancelar" })}
            </button>
            <button className={`button primary`} onClick={onClickHandler}>
              {formatMessage({ id: "continuar" })}
            </button>
          </footer>
        </div>
      </div>
    </>
  );
};

export default AddNewCpfCnpjModal;
